import React from 'react'
import "./footer.css"
const footer = () => {
  return (<footer className="flex">

<ul className="flex">
  <li>
    <a href="">About</a>
  </li>
  <li>
    <a href="">Projects</a>
    </li>
  <li>
    <a href="">Speaking</a>
    </li>
  <li>
    <a href="">Uses</a>
    </li>
</ul>

<p>@ 2025 Zienab Alaa. ALL rights reserved.</p>

  </footer>
  )
}

export default footer